// extracted by mini-css-extract-plugin
export default {"social-btn":"style_social-btn__PUOLh"};